<div class="legend-row" *ngIf="data && data.gradients">
  <calendar-tile-legend-item
    class="legend-item"
    *ngFor="let gradient of data.gradients"
    [gradient]="gradient"
    [numGradients]="data.gradients.length"
    [suffix]="suffix"
  ></calendar-tile-legend-item>
</div>
<div class="month-row">
  <calendar-month-toggle
    [data]="data.chartData"
    [selectedMonth]="selectedMonth"
    [calendarIndex]="calendarIndex"
    (monthSelected)="monthSelected($event)"
    (monthIndexSelected)="monthIndexSelected($event)"
  ></calendar-month-toggle>
</div>
<div class="week-row" *ngFor="let week of weeks; let i = index">
  <div class="day" *ngFor="let day of days">
    <div class="day-name" *ngIf="i == 0">
      {{ day.name }}
    </div>
    <div
      [ngClass]="
        calendar.data[week.y] &&
        calendar.data[week.y][day.x] &&
        calendar.data[week.y][day.x].gradient != null
          ? 'box-grad-' + calendar.data[week.y][day.x].gradient
          : ''
      "
      class="box"
      *ngIf="
        calendar &&
        calendar.data &&
        calendar.data[week.y] &&
        calendar.data[week.y][day.x]
      "
      [tooltip]="calendarTileTooltip"
      [placement]="
        day.x == 0 ? 'right' : day.x == 3 || day.x == 4 ? 'left' : 'top'
      "
      container="body"
    >
      {{ calendar.data[week.y][day.x].value
      }}<ng-container *ngIf="suffix">{{ suffix }}</ng-container>
      <ng-template #calendarTileTooltip>
        <calendar-tile-tooltip
          [date]="calendar.data[week.y][day.x].date"
          [value]="calendar.data[week.y][day.x].value"
          [suffix]="suffix"
          [numerator]="calendar.data[week.y][day.x].numerator"
          [denominator]="calendar.data[week.y][day.x].denominator"
          [descriptor]="calendar.data[week.y][day.x].descriptor"
        ></calendar-tile-tooltip>
      </ng-template>
    </div>
  </div>
</div>
